export interface QuizOption {
  value: string;
  label: string;
  description: string;
}

export interface QuizQuestion {
  id: number;
  question: string;
  subtitle: string;
  options: QuizOption[];
}

export const quizQuestions: QuizQuestion[] = [
  {
    id: 0,
    question: '현재 나의 학년은?',
    subtitle: '기본 정보를 알려주세요',
    options: [
      { value: 'elementary', label: '초등학생', description: '초등학교에 재학 중이에요' },
      { value: 'middle', label: '중학생', description: '중학교에 재학 중이에요' },
      { value: 'high', label: '고등학생', description: '고등학교에 재학 중이에요' },
      { value: 'university', label: '대학생', description: '대학교에 재학 중이에요' },
    ],
  },
  {
    id: 1,
    question: '지금 나의 가장 큰 고민은 무엇인가요?',
    subtitle: '현재 가장 신경 쓰이는 부분을 골라주세요',
    options: [
      { value: 'career-confusion', label: '어떤 직업을 가져야 할지 모르겠어요', description: '진로에 대한 막연한 불안감이 있어요' },
      { value: 'future-anxiety', label: '미래가 막막하고 자신감이 없어요', description: '앞으로 뭘 해야 할지 감이 안 와요' },
      { value: 'no-motivation', label: '공부할 의욕이 없고 방향을 잃었어요', description: '왜 공부해야 하는지 모르겠어요' },
      { value: 'ai-fear', label: 'AI·디지털 시대가 두렵고 낯설어요', description: '빠르게 변하는 기술이 부담스러워요' },
    ],
  },
  {
    id: 2,
    question: '나는 어떤 분야에 관심이 있나요?',
    subtitle: '평소에 가장 끌리는 분야를 골라주세요',
    options: [
      { value: 'science-tech', label: '과학·기술·IT', description: '새로운 기술과 과학 원리가 궁금해요' },
      { value: 'arts-culture', label: '예술·문화·창작', description: '그림, 음악, 영상, 글쓰기 등 창작 활동이 좋아요' },
      { value: 'people-society', label: '사람·사회·복지', description: '사람을 돕고 사회 문제에 관심이 있어요' },
      { value: 'law-admin', label: '법·행정·경영', description: '조직과 제도, 경영 원리에 흥미가 있어요' },
    ],
  },
  {
    id: 3,
    question: '나는 어떤 방식으로 배울 때 가장 집중이 잘되나요?',
    subtitle: '나에게 맞는 학습 스타일을 골라주세요',
    options: [
      { value: 'field-experience', label: '실제 현장을 눈으로 보면서 배우는 방식', description: '영상이나 견학으로 직접 경험하는 게 좋아요' },
      { value: 'expert-lecture', label: '전문가의 강의를 들으면서 배우는 방식', description: '체계적인 설명을 듣는 게 가장 이해가 잘돼요' },
      { value: 'self-reflection', label: '나를 돌아보는 활동을 하면서 배우는 방식', description: '일기, 명상, 대화로 깨닫는 게 많아요' },
      { value: 'new-trends', label: '최신 트렌드와 새로운 기술을 따라가면서 배우는 방식', description: '숏폼과 튜토리얼로 빠르게 흡수하는 편이에요' },
    ],
  },
  {
    id: 4,
    question: '지금 나에게 가장 필요한 것은 무엇인가요?',
    subtitle: '현재 가장 원하는 도움을 골라주세요',
    options: [
      { value: 'real-workplace', label: '실제 직업인의 하루와 업무 현장이 궁금해요', description: '진짜 직업 세계를 미리 들여다보고 싶어요' },
      { value: 'career-knowledge', label: '진로·전공과 관련된 전문 지식이 필요해요', description: '구체적인 학과나 직무 정보를 알고 싶어요' },
      { value: 'self-understanding', label: '나 자신을 더 잘 알고 싶어요', description: '내 강점과 흥미를 명확히 파악하고 싶어요' },
      { value: 'digital-skills', label: '디지털 역량을 키우고 싶어요', description: 'AI 도구와 디지털 기술을 실제로 다뤄보고 싶어요' },
    ],
  },
  {
    id: 5,
    question: '나는 어떤 콘텐츠 스타일을 선호하나요?',
    subtitle: '가장 편하게 즐길 수 있는 방식을 골라주세요',
    options: [
      { value: 'vlog-style', label: '현장감 있는 브이로그 스타일', description: '실제 현장에서 촬영한 생생한 영상이 좋아요' },
      { value: 'lecture-style', label: '체계적으로 설명해 주는 강의 스타일', description: '차근차근 정리된 강의 형식이 편해요' },
      { value: 'self-dev-style', label: '실천 과제가 포함된 자기계발 스타일', description: '직접 해보는 워크시트나 미션이 있으면 좋겠어요' },
      { value: 'tutorial-style', label: '짧고 실용적인 튜토리얼 스타일', description: '핵심만 빠르게 배울 수 있는 숏폼 콘텐츠가 좋아요' },
    ],
  },
];

export interface ContentResult {
  id: string;
  title: string;
  subtitle: string;
  description: string;
  tags: string[];
  duration: string;
  level: string;
  link: string;
  matchPercent: number;
}

// 결과와 무관하게 항상 함께 노출되는 기본 추천(기본 이수 프로그램).
export const BASELINE_PROGRAM = {
  id: 'basic-program',
  title: '기본 이수 프로그램',
  subtitle: '누구나 먼저 들으면 좋은 기본 콘텐츠예요',
  link: 'https://www.2026bokdream.org/course/course_list.jsp?cid=122291',
};

export const allContents: ContentResult[] = [
  {
    id: 'job-vlog',
    title: '직업체험 V-LOG',
    subtitle: '실제 직업인의 하루를 영상으로 체험하다',
    description: '다양한 직업에 종사하는 현직자들의 실제 하루와 업무 현장을 생생한 브이로그 영상으로 담았습니다. 직업에 대한 막연한 이미지 대신, 일하는 환경과 보람, 어려움까지 솔직하게 엿볼 수 있어 진로 선택에 큰 도움이 됩니다.',
    tags: ['직업체험', '현장감', '브이로그', '진로탐색'],
    duration: '회당 15~20분',
    level: '초·중·고·대학생',
    link: 'https://www.2026bokdream.org/course/course_list.jsp?cid=122293',
    matchPercent: 0,
  },
  {
    id: 'live-lecture',
    title: '실시간 특강',
    subtitle: '전문가에게 직접 배우는 진로·전공 지식',
    description: '각 분야 최고의 전문가와 현직자가 진행하는 실시간 온라인 특강 콘텐츠입니다. 진로와 전공에 대한 깊이 있는 지식을 체계적으로 배우고, Q&A를 통해 궁금증을 바로 해결할 수 있습니다.',
    tags: ['전문가특강', '진로지식', '실시간', '전공탐색'],
    duration: '회당 40~50분',
    level: '중·고·대학생',
    link: 'https://www.2026bokdream.org/main/page.jsp?code=live',
    matchPercent: 0,
  },
  {
    id: 'self-growth',
    title: '나를 성장시키는 힘',
    subtitle: '자기이해와 자신감을 키우는 성장 콘텐츠',
    description: '자기이해를 바탕으로 자신감을 회복하고 학습 동기를 높이는 콘텐츠입니다. 진단 테스트, 워크시트, 실천 미션을 통해 스스로를 돌아보고, 한 걸음씩 성장하는 경험을 제공합니다.',
    tags: ['자기이해', '자신감', '학습동기', '실천미션'],
    duration: '회당 20~30분',
    level: '초·중·고·대학생',
    link: 'https://www.2026bokdream.org/course/course_list.jsp?cid=122292',
    matchPercent: 0,
  },
  {
    id: 'ai-literacy',
    title: 'AI 디지털 리터러시',
    subtitle: 'AI와 디지털 기술을 이해하고 활용하는 역량 강화',
    description: '빠르게 변화하는 AI와 디지털 기술을 쉽고 재미있게 배우는 콘텐츠입니다. 두려움이 아닌 호기심으로 기술을 바라보게 하고, 실제로 AI 도구를 다뤄보며 미래에 필요한 디지털 역량을 자연스럽게 키울 수 있습니다.',
    tags: ['AI', '디지털', '리터러시', '튜토리얼'],
    duration: '회당 10~15분',
    level: '중·고·대학생',
    link: 'https://www.2026bokdream.org/course/course_list.jsp?cid=122295',
    matchPercent: 0,
  },
];

// 공식 큐레이션 배점표 (26복꿈페 맞춤형 큐레이션 로직 QA 케이스에서 확정).
// 각 선택지가 [V-LOG, 실시간특강, 성장, AI]에 주는 점수. 대상자(학년) 선택지는
// 채점 대상이 아니므로 여기에 없다(점수 0으로 무시된다).
const optionScores: Record<string, [number, number, number, number]> = {
  // Q1. 지금 나의 가장 큰 고민은?
  'career-confusion': [3, 1, 0, 0],
  'future-anxiety': [1, 1, 2, 0],
  'no-motivation': [0, 1, 3, 0],
  'ai-fear': [0, 1, 0, 3],
  // Q2. 어떤 분야에 관심?
  'science-tech': [2, 1, 0, 2],
  'arts-culture': [2, 1, 1, 0],
  'people-society': [2, 2, 1, 0],
  'law-admin': [2, 2, 0, 1],
  // Q3. 어떤 방식으로 배울 때 집중?
  'field-experience': [3, 0, 0, 0],
  'expert-lecture': [0, 3, 0, 1],
  'self-reflection': [0, 0, 3, 0],
  'new-trends': [1, 1, 0, 3],
  // Q4. 지금 가장 필요한 것?
  'real-workplace': [3, 0, 0, 0],
  'career-knowledge': [1, 3, 0, 0],
  'self-understanding': [0, 0, 3, 0],
  'digital-skills': [0, 1, 0, 3],
  // Q5. 선호 콘텐츠 스타일?
  'vlog-style': [3, 0, 0, 0],
  'tutorial-style': [1, 1, 0, 3],
  'lecture-style': [0, 3, 1, 1],
  'self-dev-style': [0, 0, 3, 0],
};

const CATEGORY_IDS = ['job-vlog', 'live-lecture', 'self-growth', 'ai-literacy'] as const;

// 5개 답의 점수를 카테고리별로 합산 → 최고점 카테고리를 추천한다. 동점이면
// 최고점 카테고리를 모두 반환한다(1~여러 개). 대상자(학년) 답은 optionScores에
// 없으므로 자동으로 무시된다.
export function calculateRecommendation(answers: string[]): ContentResult[] {
  const totals: [number, number, number, number] = [0, 0, 0, 0];
  answers.forEach((answer) => {
    const s = optionScores[answer];
    if (!s) return;
    for (let i = 0; i < 4; i += 1) totals[i] += s[i];
  });

  const maxScore = Math.max(...totals);
  // 문항 5개 각 최대 3점 → 이론상 15점 만점 기준으로 매칭도 산출(표시용).
  const matchPercent = Math.min(99, Math.max(1, Math.round((maxScore / 15) * 100)));

  const winners: ContentResult[] = [];
  CATEGORY_IDS.forEach((id, i) => {
    if (totals[i] === maxScore) {
      const c = allContents.find((x) => x.id === id);
      if (c) winners.push({ ...c, matchPercent });
    }
  });
  return winners;
}